import isEmpty from 'is-empty';
import {
  WITHDRAW_FT_TIP_INVESTMENT,
  WITHDRAW_FT_TIP_INVESTMENT_ERROR,
  WITHDRAW_FT_TIP_INVESTMENT_LOADING,
  WITHDRAW_FT_TIP_INVESTMENT_ERROR_DELETE
} from '../../actions/types';

const initialState = {
  success: false,
  withdrawFixLip: {},
  error: '',
  loading: false
};

const withdrawFixLip = (state = initialState, action) => {
  switch (action.type) {
    case WITHDRAW_FT_TIP_INVESTMENT:
      return {
        ...state,
        success: !isEmpty(action.withdrawFixTip),
        withdrawFixLip: action.withdrawFixTip,
        loading: false
      };
    case WITHDRAW_FT_TIP_INVESTMENT_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case WITHDRAW_FT_TIP_INVESTMENT_ERROR_DELETE:
      return {
        error: ''
      };
    case WITHDRAW_FT_TIP_INVESTMENT_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};

export default withdrawFixLip;